<input #input type="text">


// WEBPACK FOOTER //
// /app/src/app/components/color-picker/color-picker.component.ts.ColorPickerComponent.html